var map = {
	"./payment_methods/2_credit_cards.svg": [
		"./src/assets/payment_methods/2_credit_cards.svg",
		"icons/icon-payment_methods-2_credit_cards-svg"
	],
	"./payment_methods/apple_pay.svg": [
		"./src/assets/payment_methods/apple_pay.svg",
		"icons/icon-payment_methods-apple_pay-svg"
	],
	"./payment_methods/bank_transfer.svg": [
		"./src/assets/payment_methods/bank_transfer.svg",
		"icons/icon-payment_methods-bank_transfer-svg"
	],
	"./payment_methods/boleto.svg": [
		"./src/assets/payment_methods/boleto.svg",
		"icons/icon-payment_methods-boleto-svg"
	],
	"./payment_methods/click_to_pay.svg": [
		"./src/assets/payment_methods/click_to_pay.svg",
		"icons/icon-payment_methods-click_to_pay-svg"
	],
	"./payment_methods/credit_card.svg": [
		"./src/assets/payment_methods/credit_card.svg",
		"icons/icon-payment_methods-credit_card-svg"
	],
	"./payment_methods/credit_card_and_boleto.svg": [
		"./src/assets/payment_methods/credit_card_and_boleto.svg",
		"icons/icon-payment_methods-credit_card_and_boleto-svg"
	],
	"./payment_methods/debit_card.svg": [
		"./src/assets/payment_methods/debit_card.svg",
		"icons/icon-payment_methods-debit_card-svg"
	],
	"./payment_methods/google_pay.svg": [
		"./src/assets/payment_methods/google_pay.svg",
		"icons/icon-payment_methods-google_pay-svg"
	],
	"./payment_methods/pix.svg": [
		"./src/assets/payment_methods/pix.svg",
		"icons/icon-payment_methods-pix-svg"
	],
	"./payment_methods/voucher.svg": [
		"./src/assets/payment_methods/voucher.svg",
		"icons/icon-payment_methods-voucher-svg"
	],
	"./review/billing.svg": [
		"./src/assets/review/billing.svg",
		"icons/icon-review-billing-svg"
	],
	"./review/boleto.svg": [
		"./src/assets/review/boleto.svg",
		"icons/icon-review-boleto-svg"
	],
	"./review/pix.svg": [
		"./src/assets/review/pix.svg",
		"icons/icon-review-pix-svg"
	],
	"./review/recipient.svg": [
		"./src/assets/review/recipient.svg",
		"icons/icon-review-recipient-svg"
	],
	"./review/shipping.svg": [
		"./src/assets/review/shipping.svg",
		"icons/icon-review-shipping-svg"
	],
	"./review/user.svg": [
		"./src/assets/review/user.svg",
		"icons/icon-review-user-svg"
	],
	"./success/Info.svg": [
		"./src/assets/success/Info.svg",
		"icons/icon-success-Info-svg"
	],
	"./success/success.svg": [
		"./src/assets/success/success.svg",
		"icons/icon-success-success-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;